import { inject, Injectable } from '@angular/core';
import { ApiServiceBase, RequestMethod } from '@api/abstracts';
import { environment } from '@environments/environment';
import { CacheService } from '@services/cache';
import { StoresMiddleOffice } from '@services/middle-office/model';
import { BehaviorSubject, from, map, Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MiddleOfficeService extends ApiServiceBase<StoresMiddleOffice> {
  currentStoreUuid$ = new BehaviorSubject<string | null>(null);
  readonly #cacheService = inject(CacheService);

  constructor() {
    super('');
  }

  isMiddleOfficeToken$(): Observable<boolean> {
    return from(this.#cacheService.get('middleOfficeToken')).pipe(map((middleOfficeToken) => !!middleOfficeToken));
  }

  getStores$(token: string, cache = false): Observable<StoresMiddleOffice> {
    return cache
      ? from(this.#cacheService.get('middleOfficeStores') as Promise<StoresMiddleOffice>).pipe(
          switchMap((storesMiddleOffice) => (storesMiddleOffice ? of(storesMiddleOffice) : this.getStoresRest$(token)))
        )
      : this.getStoresRest$(token);
  }

  private getStoresRest$(token: string): Observable<StoresMiddleOffice> {
    return super
      .customRequest<StoresMiddleOffice>(RequestMethod.GET, 'userinfos', {
        params: { token },
      })
      .pipe(
        switchMap((stores) => {
          environment.isCacheEnabled = false;
          const expirationDate = (stores.expiredate * 1000 - Date.now()) / 1000;
          return from(
            this.#cacheService.set('middleOfficeStores', stores, expirationDate ?? 0) as Promise<StoresMiddleOffice>
          );
        })
      );
  }
}
